import {createRef, useEffect, useState} from "react";
import '../../static/css/timepicker/time.css';
import {CheckIcon, ThinCaretDownIcon, ThinCloseIcon, ThinTimeIcon} from "../icons/material-icons";
import {ShowSnackbar} from "../template/snackbar";
import ClickOutsideDetector from "../clickOutside/click-outside";
import {Calendar, Day, DayValue} from "@hassanmojab/react-modern-calendar-datepicker";
import {GregorianToPersian, PersianToGregorian} from "../techaran/date-convert";
import {StringDigitsConvertToPersian} from "../techaran/money";

export const TimePicker = (props:{lang:string,hour:number,minute:number,setState:any,title:string,locked:boolean,onSave:any,date:string,setDate:any,hasDate:boolean,openUp?:boolean}) => {
    const [isOpen,setIsOpen] = useState(false);
    const [hour,setHour] = useState(0);
    const [minute,setMinute] = useState(0);
    const [hourPosition, setHourPosition] = useState("0px");
    const [minutePosition, setMinutePosition] = useState("0px");
    const [hourList, setHourList] = useState([] as number[]);
    const [minuteList, setMinuteList] = useState([] as number[]);
    const [date,setDate] = useState<DayValue>(null);
    const [maxDate,setMaxDate] = useState<Day|undefined>(undefined);
    const [minDate,setMinDate] = useState<Day|undefined>(undefined);
    const refs = {
        hourUp:createRef<any>(),
        hourDown:createRef<any>(),
        minUp:createRef<any>(),
        minDown:createRef<any>(),
    };
    useEffect(()=>{
        const _hour = props.hour;
        const _min = props.minute;
        setHour(_hour );
        setMinute(_min);
        setHourList(Array.from({length: 24}, (v, i) => i));
        setMinuteList(Array.from({length: 60}, (v, i) => i));
        setHourPosition((_hour - 1) * -40 + "px");
        setMinutePosition((_min - 1) * -40 + "px");
    },[props.hour,props.minute]);
    useEffect(() => {
        const isDate = props.hasDate;
        let _date = props.date;
        if(isDate) {
            let a = _date;
            if(props.lang === 'fa')
                a = GregorianToPersian(_date);
            let d = a.split('-');
            setDate({
                year:parseInt(d[0]),
                month:parseInt(d[1]),
                day:parseInt(d[2]),
            });

            // Min and Max dates
            const today = new Date();
            let todayIso = new Date().toISOString().split('T')[0];
            if(props.lang === 'fa')
                todayIso = GregorianToPersian(todayIso);
            const todayArr = todayIso.split('-');
            setMaxDate({
                year:parseInt(todayArr[0]),
                month:parseInt(todayArr[1]),
                day:parseInt(todayArr[2]),
            });

            const priorDate = new Date(new Date().setDate(today.getDate() - 2));
            let priorIso = priorDate.toISOString().split('T')[0];
            if(props.lang === 'fa')
                priorIso = GregorianToPersian(priorIso);
            const priorArr = priorIso.split('-');
            setMinDate({
                year:parseInt(priorArr[0]),
                month:parseInt(priorArr[1]),
                day:parseInt(priorArr[2]),
            });
        }
    }, [props.date,props.hasDate]);
    useEffect(()=>{
        let timeout: NodeJS.Timer;
        const scrollHourUp = (e:MouseEvent) => {
            if(e.type === 'mousedown'){
                    timeout = setInterval(() => {
                        const _hour = hour;
                        if (_hour > 0) {
                            setHour(_hour - 1);
                            setHourPosition((_hour - 2) * -40 + "px");
                        }
                    }, 100);
            } else
                clearInterval(timeout);
        };

        const scrollHourDown = (e:MouseEvent) => {
            if(e.type === 'mousedown'){
                timeout = setInterval(() => {
                    const _hour = hour;
                    if(_hour < 23) {
                        setHour(_hour + 1);
                        setHourPosition(_hour * -40 + "px");
                    }
                }, 100);
            } else
                clearInterval(timeout);
        };
        const scrollMinuteUp = (e:MouseEvent) => {
            if(e.type === 'mousedown'){
                timeout = setInterval(() => {
                    const _min = minute;
                    if(_min > 0){
                        setMinutePosition((_min - 2) * -40 + "px");
                        setMinute(_min - 1);
                    }
                }, 100);
            } else
                clearInterval(timeout);
        };
        const scrollMinuteDown = (e:MouseEvent) => {
            if(e.type === 'mousedown'){
                timeout = setInterval(() => {
                    const _min = minute;
                    if(_min < 59){
                        setMinute(_min + 1);
                        setMinutePosition(_min  * -40 + "px");
                    }
                }, 100);
            } else
                clearInterval(timeout);
        };

        // (refs.hourUp.current as HTMLButtonElement).addEventListener('mousedown',scrollHourUp,false);
        // (refs.hourUp.current as HTMLButtonElement).addEventListener('mouseup',scrollHourUp,false);

        // (refs.hourDown.current as HTMLButtonElement).addEventListener('mousedown',scrollHourDown,false);
        // (refs.hourDown.current as HTMLButtonElement).addEventListener('mouseup',scrollHourDown,false);

        // (refs.minUp.current as HTMLButtonElement).addEventListener('mousedown',scrollMinuteUp,false);
        // (refs.minUp.current as HTMLButtonElement).addEventListener('mouseup',scrollMinuteUp,false);

        // (refs.minDown.current as HTMLButtonElement).addEventListener('mousedown',scrollMinuteDown,false);
        // (refs.minDown.current as HTMLButtonElement).addEventListener('mouseup',scrollMinuteDown,false);

    },[]);
    const setTimeState = () => {
        const h = hour;
        const m = minute;
        props.setState(h,m);
        const hasDate = props.hasDate;
        if(hasDate){
            const _date = {...date};
            let year:string,month:string,day:string;
            let dateString;
            if(props.lang === 'fa'){
                const dateGregorian = PersianToGregorian(`${_date.year}-${_date.month}-${_date.day}`).split('-');
                year = dateGregorian[0];
                month = dateGregorian[1];
                day = dateGregorian[2];
            } else {
                year = _date.year?.toString() as string;
                month = _date.month?.toString() as string;
                day = _date.day?.toString() as string;
            }
            dateString = `${year}-${month.length<2?`0${month}`:month}-${day.length<2?`0${day}`:day} ${h > 9 ? h : `0${h}`}:${m > 9 ? m:`0${m}`}:00`;
            props.setDate(dateString);
        }
    };
    return (
        <>
            <div className={"timepicker" + (isOpen ? ' active':'') + (props.locked ? ' locked':'')}>
                <div className="timepicker-content" onClick={()=> {
                    const isLocked = props.locked;
                    const _hour = props.hour;
                    const _min = props.minute;
                    if(!isLocked) {
                        setIsOpen(true);
                        setHour(_hour);
                        setMinute(_min);
                        setHourList(Array.from({length: 24}, (v, i) => i));
                        setMinuteList(Array.from({length: 60}, (v, i) => i));
                        setHourPosition((_hour - 1) * -40 + "px");
                        setMinutePosition((_min - 1) * -40 + "px");
                    }
                    else {
                        ShowSnackbar(
                           'لطفا ابتدا قفل این فیلد زمانی را باز کنید.',
                            'باشه',
                            5000,
                        );
                    }
                }}>
                    <div className="timepicker-content-inside">
                        <ThinTimeIcon/>
                        <div>
                            {props.title.length > 0 ? <i className="f-roboto">{props.title}</i> : null}
                            <div className="timepicker-content-inside-times">
                                {
                                    props.hasDate ?
                                        <span>{StringDigitsConvertToPersian(GregorianToPersian(props.date).replaceAll('-','/'))}</span> : null
                                }
                                <span>{StringDigitsConvertToPersian((props.hour > 9)?props.hour:`0${props.hour}`)}:{StringDigitsConvertToPersian((props.minute > 9)?props.minute:`0${props.minute}`)}</span>
                            </div>
                        </div>
                    </div>
                    <ThinCaretDownIcon/>
                </div>
                <ClickOutsideDetector
                    onClickOutside={()=>{
                        setIsOpen(false);
                    }}
                    className={"timepicker-open" + (props.hasDate ? ' extended':'')}
                    data-open-up={props.openUp === true ? '1' : '0'}>
                    {
                        props.hasDate && isOpen ?
                            <div className="timepicker-date">
                                <Calendar
                                    shouldHighlightWeekends
                                    colorPrimary='#0a53be'
                                    locale={props.lang}
                                    value={date}
                                    onChange={e=>setDate(e)}
                                    //maximumDate={maxDate}
                                    //minimumDate={minDate}
                                />
                            </div> : null
                    }
                    {
                        isOpen ?
                            <>
                                <div className="timepicker-part">
                                    <button className="timepicker-scrolls" style={{top: 5}} onClick={() => {
                                        const _hour = hour;
                                        if(_hour > 0){
                                            setHour(_hour - 1);
                                            setHourPosition((_hour - 2) * -40 + "px");
                                        }
                                    }} ref={refs.hourUp}>
                                        <ThinCaretDownIcon/>
                                    </button>
                                    <div className="timepicker-times">
                                        <div className="timepicker-times-container" style={{"top": hourPosition}}>
                                            {
                                                hourList.map((t, i) =>
                                                    <div key={"cGrJBdI" + i} className={hour === t ? 'active':''} onClick={() => {
                                                        setHour(t);
                                                        setHourPosition((t - 1) * -40 + "px");
                                                    }}>
                                                        {StringDigitsConvertToPersian(t < 10 ? `0${t}`:t)}
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <button data-rev="1" className="timepicker-scrolls" style={{bottom: 5}} onClick={() => {
                                        const _hour = hour;
                                        if(_hour < 23) {
                                            setHour(_hour + 1);
                                            setHourPosition(_hour * -40 + "px");
                                        }
                                    }} ref={refs.hourDown}>
                                        <ThinCaretDownIcon/>
                                    </button>
                                </div>
                                <div className="timepicker-part">
                                    <button className="timepicker-scrolls" style={{top: 5}} onClick={() => {
                                        const _min = minute;
                                        if(_min > 0){
                                            setMinutePosition((_min - 2) * -40 + "px");
                                            setMinute(_min - 1);
                                        }
                                    }} ref={refs.minUp}>
                                        <ThinCaretDownIcon/>
                                    </button>
                                    <div className="timepicker-times">
                                        <div className="timepicker-times-container" style={{"top": minutePosition}}>
                                            {
                                                minuteList.map((t, i) =>
                                                    <div key={"cGrJBdI" + i} className={minute === t ? 'active' : ''} onClick={() => {
                                                        setMinute(t);
                                                        setMinutePosition((t - 1) * -40 + "px");
                                                    }}>
                                                        {StringDigitsConvertToPersian(t < 10 ? `0${t}`:t)}
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <button data-rev="1" className="timepicker-scrolls" style={{bottom: 5}} onClick={() => {
                                        const _min = minute;
                                        if(_min < 59){
                                            setMinute(_min + 1);
                                            setMinutePosition(_min  * -40 + "px");
                                        }
                                    }} ref={refs.minDown}>
                                        <ThinCaretDownIcon/>
                                    </button>
                                </div>
                                <div className="timepicker-part">
                                    <button className="timepicker-scrolls" style={{top: 5}} onClick={() => {
                                        setIsOpen(false);
                                    }}>
                                        <ThinCloseIcon/>
                                    </button>
                                    <button data-main="1" data-rev="1" className="timepicker-scrolls" style={{bottom: 5}}
                                            onClick={() => {
                                                setTimeState();
                                                setIsOpen(false);
                                                props.onSave();
                                            }}>
                                        <CheckIcon/>
                                    </button>
                                </div>
                            </> : null
                    }
                </ClickOutsideDetector>
            </div>
        </>
    );
};